const operation = {
    AUTHENTICATION: "Authentication",
    PAYMENT_STARTED: "StartPayment",
    PAYMENT_SUCCESS: "PaymentSuccess",
    PAYMENT_ERROR: "PaymentError",
    PAYMENT_CANCELED: "PaymentCanceled",
}

export default operation;